import React from "react";
import "./replayBlockVisualsToggle.css";

// Interruptor de dos opciones del panel izquierdo (repetición, análisis y espectador).
export default function ReplayBlockVisualsToggle({ value, onChange, hasRealDesigns = true, className = "" }) {
  const current = hasRealDesigns && value !== "default" ? "real" : "default";
  const options = [
    { id: "real", label: "Bloques reales", title: "Ver con los bloques que usó cada jugador" },
    { id: "default", label: "Bloques por defecto", title: "Ver con bloques por defecto (sin diseños de los jugadores)" },
  ];

  return (
    <section className={`r7-card r7-blockvis ${className}`.trim()}>
      <div className="r7-blockvis-label">Ver con</div>
      <div className="r7-blockvis-row" role="radiogroup" aria-label="Diseño de los bloques">
        {options.map((option) => {
          const disabled = option.id === "real" && !hasRealDesigns;
          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={current === option.id}
              className={`r7-blockvis-btn${current === option.id ? " is-on" : ""}`}
              disabled={disabled}
              title={option.title}
              onClick={() => {
                if (!disabled && option.id !== current && typeof onChange === "function") onChange(option.id);
              }}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      {!hasRealDesigns ? (
        <div className="r7-blockvis-note">Esta partida no guardó los diseños de los bloques.</div>
      ) : null}
    </section>
  );
}
